import React from 'react'

const FormInput = ({
  name,
  type,
  placeholder,
  disabled,
  value,
  onBlur,
  onChange,
  defaultChecked,
  max = null,
  min = null,
  autoComplete = false,
  ariaLabel,
  id,
}) => {
  return max || min ? (
    <input
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      className="forminput formfield__input"
      type={type ? type : 'text'}
      disabled={disabled}
      placeholder={placeholder}
      defaultChecked={defaultChecked}
      maxLength={max}
      minLength={min}
      {...(!autoComplete ? { autoComplete: 'off' } : {})}
      id={id}
      aria-label={ariaLabel}
    />
  ) : (
    <input
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      className="forminput formfield__input"
      type={type ? type : 'text'}
      disabled={disabled}
      placeholder={placeholder}
      defaultChecked={defaultChecked}
      {...(!autoComplete ? { autoComplete: 'off' } : {})}
      id={id}
      aria-label={ariaLabel}
    />
  )
}

export default FormInput
